import { fg } from '@confluence/feature-gating';
import { createSingleQueryParamHook } from '@confluence/route-manager/entry-points/RouteState.ts';

const AI_PLANNER_PARENT_PRODUCT = 'ai-planner';
const useParentProductQueryParam = createSingleQueryParamHook('parentProduct');

export function useShouldRegisterAIPlannerRovoBridge(): boolean {
	const parentProduct = useParentProductQueryParam();

	return (
		// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
		parentProduct === AI_PLANNER_PARENT_PRODUCT && fg('confluence_ai_planner_rovo_bridge_streaming')
	);
}
